import { bookUpdate } from "../action";

const updateBook = (bookId, book, filterStatus) => {
  return async (dispatch) => {
    const response = await fetch(`http://localhost:9000/books/${bookId}`, {
      method: "PATCH",
      body: JSON.stringify({
        ...book,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    });
    const updatedBook = await response.json();

    dispatch(bookUpdate(updatedBook, filterStatus));
  };
};

export default updateBook;
